<template>
  <div v-if="Array.isArray(value)">
    <info-toggle :infoContent="i18n_local.whoAreGuests" size="small" />

    <div
      v-for="(guest, index) in value"
      :key="`guest-${index}`"
      class="md-layout"
    >
      <!-- <div class="md-layout-item md-size-50 md-small-size-100"> -->
      <div class="md-layout-item guest-data-container mb-2">
        <md-button
          v-if="index !== 0 && !readonly"
          @click="deleteGuest(index)"
          class="md-icon-button remove-guest-button"
        >
          <md-icon>clear</md-icon>
        </md-button>
        <guest-data
          :name="guest.name"
          :email="guest.email"
          :phone="guest.phone"
          :sequence-number="guest.seq"
          :readonly="readonly"
          @changed="onGuestChanged"
        ></guest-data>

      </div>
      <!-- <div
        class="md-layout-item md-size-50 md-small-size-50 align-items-center justify-content-center d-flex"
      >
        <md-button
          v-if="index !== 0 && !readonly"
          @click="deleteGuest(index)"
          class="md-icon-button"
        >
          <md-icon>delete</md-icon>
        </md-button>
      </div>-->
    
    </div> 
    <md-button
      v-if="!readonly"
      @click="addGuest"
      class="md-primary play-cta-button makeup"
      >Add guest</md-button
    >
  </div>
</template>

<script>
    import GuestData from './GuestData.vue';
    import InfoToggle from "@/components/interface/buttons/infoToggle.vue";
    import { mapGetters } from "vuex";

    export default {
        name: "GuestsBlock",
        components: { GuestData, InfoToggle },
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            readonly: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            ...mapGetters("internationalizationModule", ["i18n_local"]),
        },
        methods: {
            getGuestsArray() {
                return this.value.map(item => item);
            },
            onGuestChanged(guest) {
                const index = this.value.findIndex(item => item.seq === guest.seq);
                const guests = this.getGuestsArray();
                if (index >= 0) {
                    guests[index] = guest;
                }
                else {
                    guests.push(guest);
                }

                this.$emit('input', guests);
            },
            deleteGuest(index) {
                const guests = this.getGuestsArray();
                guests.splice(index, 1);

                this.$emit('input', guests);
            },
            addGuest() {
                const guests = this.getGuestsArray();
                guests.push({
                    name: '',
                    phone: '',
                    email: '',
                    seq: this.value.length,
                });

                this.$emit('input', guests);
            },
        }
    }
</script>

<style scoped>
.guest-data-container{
  border: 1px solid grey;
  border-radius: 8px;
  padding: 1em;
  position: relative;
}

.remove-guest-button{
      position: absolute;
    right: 0em;
    top: 0em;
}
</style>


// WEBPACK FOOTER //
// src/components/bookings/deals/GuestsBlock.vue